import * as React from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { Close as CloseIcon, Phone as PhoneIcon } from "@mui/icons-material";

const CONTACTS = [
  { phone: '+919822412353', display: '+91 - 9822412353', label: 'Primary Contact' },
  { phone: '+918459583479', display: '+91 - 8459583479', label: 'Secondary Contact' },
];

// Popup with the sales phone numbers; tapping a number starts a call.
export default function ContactModal({ open, onClose, title, message }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="contact-modal-title"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isMobile ? '90%' : 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="contact-modal-title" variant="h6" component="h2" fontWeight="bold">
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography sx={{ mb: 3 }} color="text.secondary">
          {message}
        </Typography>

        <Stack spacing={2}>
          {CONTACTS.map((contact) => (
            <Paper
              key={contact.phone}
              elevation={2}
              sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                cursor: 'pointer',
                '&:hover': { bgcolor: 'action.hover' }
              }}
              onClick={() => window.open(`tel:${contact.phone}`, '_self')}
            >
              <PhoneIcon color="primary" />
              <Box>
                <Typography variant="body1" fontWeight="medium">
                  {contact.display}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {contact.label}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Stack>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button onClick={onClose} variant="outlined">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
